export default {
  common: {
    welcome: '欢迎您～',
    language: '语言',
    switchLanguage: '切换语言成功',
    chinese: '中文',
    english: '英文',
    logout: '退出登录',
    myOrder: '我的订单',
    confirmLogout: '确认登出账户？',
    logoutSuccess: '退出成功',
    remainingTimes: '剩余次数',
    times: '次',
    unlimited: '无限',
    confirm: '确定',
    cancel: '取消',
    companyName: '北美无限公司',
    tip: '提示',
    copySuccess: '复制成功',
    copyFailed: '复制失败',
    loading: '加载中...'
  },
  button: {
    submit: '提交',
    cancel: '取消',
    confirm: '确认',
    save: '保存',
    delete: '删除',
    edit: '编辑',
    search: '搜索'
  },
  message: {
    success: '操作成功',
    error: '操作失败',
    loading: '加载中...',
    noData: '暂无数据'
  },
  nav: {
    home: '首页',
    about: '关于',
    contact: '联系我们'
  },
  login: {
    title: '请选择登录方式',
    merchantLogin: '商家登录',
    bloggerLogin: '博主登录',
    photographerLogin: '摄影登录',
    advertiserLogin: '广告商登录',
    accountPlaceholder: '请输入账号',
    passwordPlaceholder: '请输入密码',
    loginButton: '登录',
    loginSuccess: '登录成功',
    loginFailed: '登录失败，请检查账号密码',
    fillAccountPassword: '请填写账号和密码'
  },
  menu: {
    aiCreation: 'AI创作',
    draftReview: '草稿审核&反馈',
    publishManagement: '发布管理',
    purchasePackage: '购买套餐'
  },
  aiCreation: {
    generateContent: '生成内容',
    inputContent: '输入内容',
    inputPlaceholder: '请输入您的创作需求...',
    startDesign: '开始设计',
    recreate: '重新创作',
    generateResult: '生成结果',
    article: '文章',
    image: '图片',
    video: '视频',
    noTask: '暂无任务',
    noTaskDesc: '目前没有被分配任何任务，请稍后查看',
    generating: '正在生成',
    completed: '已完成',
    download: '下载',
    downloadSuccess: '下载成功',
    noDownloadContent: '没有可下载的内容',
    ratio: '比例',
    ratioRequired: '分辨率*',
    duration: '时长',
    durationRequired: '时长*',
    uploadImage: '上传图片',
    uploadVideo: '上传参考视频',
    inputTag: '输入标签',
    disclaimer: '本页面内容由AI技术生成，不涉及平台主观观念，内容仅作为信息参考，不构成任何法律建议，不对其性质、标准、准确性等基于任何形式的承诺或陈述。',
    previewImage: '预览图片',
    preview: '预览',
    delete: '删除',
    createFailed: '创建任务失败，请稍后重试',
    detailFailed: '获取任务详情失败，请稍后重试',
    generationFailed: '生成失败',
    generationFailedDesc: '请重新尝试生成内容，生成失败不消耗使用次数',
    retryGeneration: '请在左侧重新尝试生成',
    copy: '复制',
    copySuccess: '复制成功',
    copyFailed: '复制失败',
    noCopyContent: '没有可复制的内容',
    historyRecord: '历史记录',
    backToCurrent: '返回当前',
    noHistory: '暂无历史记录',
    textToVideo: '文字生成视频',
    imageToVideo: '图片生成视频',
    videoToVideo: '视频生成视频',
    resetSuccess: '已重置，可以重新创作',
    noDescription: '无描述',
    noContent: '无内容',
    imageUploadSuccess: '图片上传成功',
    imageUploadFailed: '图片上传失败',
    videoUploadSuccess: '视频上传成功',
    videoUploadFailed: '视频上传失败',
    imageDeleteSuccess: '图片删除成功',
    pleaseInputText: '请输入提示文本',
    pleaseUploadImage: '请上传参考图片',
    pleaseSelectRatio: '请选择分辨率',
    pleaseSelectDuration: '请选择时长',
    pleaseUploadVideo: '请上传参考视频',
    taskGenerating: '任务正在生成中，请稍后重试',
    translating: '正在翻译...',
    getHistoryFailed: '获取历史记录失败',
    switchTypeConfirm: '切换类型将清空当前内容，是否继续？',
    videoLoadFailed: '视频加载失败，请检查网络或稍后重试'
  },
  review: {
    pending: '待审核',
    passed: '审核通过',
    rejected: '审核驳回',
    pendingTab: '待审核',
    passedTab: '审核通过',
    rejectedTab: '审核驳回',
    packageName: '套餐名称',
    linkId: '关联ID',
    draftSource: '草稿来源',
    publishPlatform: '发布平台',
    title: '标题',
    content: '内容',
    pusher: '推送人',
    pushTime: '推送时间',
    reviewStatus: '审核状态',
    operation: '操作',
    review: '审核',
    view: '查看',
    reviewDetail: '审核详情',
    type: '类型',
    historyReview: '历史审核意见',
    reviewResult: '审核结果',
    reviewTime: '审核时间',
    reviewOpinion: '审核意见',
    reviewPass: '审核通过',
    reviewReject: '审核驳回',
    inputReviewOpinion: '请输入审核意见',
    reviewSuccess: '审核成功',
    reviewFailed: '审核失败',
    pass: '通过',
    reject: '拒绝'
  },
  publish: {
    totalCount: '总数量',
    waitingCount: '等待审核数量',
    publishedCount: '已发布数量',
    remainingCount: '剩余数量',
    selectPackage: '请选择',
    publishLink: '发布链接',
    publisher: '发布者',
    publishTime: '发布时间',
    copyContent: '复制内容',
    copyLink: '复制链接',
    linkCopied: '复制成功',
    copyFail: '复制失败',
    noLink: '暂无链接',
    noData: '暂无数据'
  },
  purchase: {
    packageList: '套餐列表：',
    orderNow: '立即订购',
    agreeService: '购买即代表您已同意',
    serviceAgreement: '《付费服务协议》',
    pleaseAgreeService: '请先同意付费服务协议',
    paymentMethod: '支付方式',
    crossBankTransfer: '跨行转账',
    paidAndSent: '我已付款并发送邮箱',
    tip: '提示',
    sendScreenshotTo: '付款后请上传支付截图发送至邮箱：',
    wechatId: '微信号：',
    singlePackage: '单次套餐',
    monthlyPackage: '1个月套餐',
    threeMonthPackage: '3个月套餐',
    unlimitedPackage: '无限套餐',
    insPost: 'ins推文',
    youtubePost: 'YouTube推文',
    facebookPost: 'Facebook推文',
    aiCreation: 'AI创作',
    unlimited: '无限',
    times: '次',
    friendlyReminder: '温馨提示',
    paymentConfirmMessage: '请确保您已将支付截图发送至邮箱，我们将尽快核实您的支付信息并给您反馈，谢谢',
    iUnderstand: '我知道了'
  },
  order: {
    orderList: '订单列表',
    orderNo: '订单编号',
    packageName: '购买套餐',
    packageContent: '套餐内容',
    purchaseTime: '购买时间',
    orderStatus: '订单状态',
    payTime: '支付时间',
    pending: '待支付',
    paid: '已支付',
    completed: '已完成',
    cancelled: '已取消',
    orderDetail: '订单详情',
    orderAmount: '订单金额',
    orderTime: '下单时间',
    unpaid: '未支付',
    paymentSuccess: '支付成功',
    callbackFailed: '回调接口调用失败',
    orderListFailed: '获取订单列表失败',
    searchOrderNo: '请输入订单号搜索'
  }
}
